<template>
  <transition name="el-zoom-in-center">
    <el-dialog
      title="注册"
      :visible.sync="add.addshow"
      width="45%"
      center
      @close="resetForm('form')"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="110px" :rules="rules">
        <el-form-item label="经销商类型" prop="depart_type">
          <el-select v-model="form.depart_type" placeholder="请选择" style="width:50%" disabled>
            <el-option
              v-for="item in depart_type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="companyName">
          <el-input v-model.trim="form.companyName" style="width:50%" />
        </el-form-item>
        <el-form-item label="编码" prop="departCode">
          <el-input v-model.trim="form.departCode" style="width:50%" />
        </el-form-item>
        <el-form-item label="所属上级" prop="parentUserUuidlist">
          <el-cascader
            v-model.trim="form.parentUserUuidlist"
            style="width:50%"
            :props="parentProps"
            :show-all-levels="true"
            :options="dealertree"
            filterable
          />
        </el-form-item>
        <div v-show="form.depart_type==2||form.depart_type==3">
          <el-form-item label="联系人" prop="name">
            <el-input v-model.trim="form.name" style="width:50%" />
          </el-form-item>
          <el-form-item label="联系人电话" prop="phone">
            <el-input v-model.trim="form.phone" style="width:50%" />
          </el-form-item>
          <el-form-item label="选择地区">
            <el-col :span="7">
              <el-select
                style="width:90%"
                clearable
                v-model="form.province_id"
                placeholder="请选择省份"
                @change="getcity(form.province_id)"
              >
                <el-option
                  v-for="item in province"
                  :key="item.code"
                  :label="item.province"
                  :value="item.code"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                style="width:90%"
                clearable
                v-model="form.city_id"
                placeholder="请选择市"
                @change="getdistrict(form.city_id)"
              >
                <el-option
                  v-for="item in city"
                  :key="item.code"
                  :label="item.city"
                  :value="item.code"
                />
              </el-select>
            </el-col>
            <el-col :span="9">
              <el-select clearable v-model="form.area_id" @change="getareaname(form.area_id)" style="width:90%" placeholder="请选择区">
                <el-option
                  v-for="item in district"
                  :key="item.code"
                  :label="item.area"
                  :value="item.code"
                />
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model.trim="form.address" type="textarea" style="width:50%" />
          </el-form-item>
        </div>
        <el-form-item label="关联业务部门" prop="companyName" v-show="form.depart_type==3">
          <el-cascader
            v-model="form.relation_departCodelist"
            style="width:50%"
            :props="elselectProps"
            :show-all-levels="true"
            :options="departtree"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="add.addshow=false">取 消</el-button>
        <el-button type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </transition>
</template>
<script>
import {
  findByParentCode,
  departtree,
  sectionadd,
  sectionup,
  sectiondelete,
  list
} from "@/api/orgin";
import { registeruser } from "@/api/market/channel";
import { construct, destruct } from "@aximario/json-tree";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null
        };
      }
    }
  },
  data() {
    // 验证编号
    function validateaccount(rule, value, callback) {
      var MobileRegex = /^[0-9a-zA-Z]+$/;
      if (!MobileRegex.test(value)) {
        callback(new Error("编码必须为英文或者数字组成！"));
      }
      list({ depart_code: value }).then(response => {
        if (response.data.length >= 1) {
          callback(new Error("编码不能重复"));
        } else {
          callback();
        }
      });
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      //基础数据
      // 省市区联动下拉
      arr: [1, 3, 4],
      tableData: [],
      datalist: [],
      province: [],
      city: [],
      district: [],
      show: true,
      // 列表转分级树数据
      elselectProps: {
        children: "listSubWareHouses",
        label: "depart_name",
        value: "depart_code",
        id: "depart_uuid",
        checkStrictly: true
      },
      parentProps: {
        children: "listSubWareHouses",
        label: "depart_name",
        value: "depart_uuid",
        id: "depart_uuid",
        checkStrictly: true
      },
      departtree: null, // 掉接口返回部门树
      dealertree: null,
      // 分级树过滤end
      // 弹窗form
      depart_type: [
        { value: 0, label: "内部其他机构" },
        { value: 1, label: "内部营销机构" },
        { value: 2, label: "公司仓库管理" },
        { value: 3, label: "经销商管理" }
      ],
      form: {
        companyName: null,
        depart_uuid: null,
        parentUserUuidlist: [],
        parentUserUuid: null,
        depart_type: 3,
        departCode: null,
        name: null,
        phone: null,
        province_id: "",
        city_id: "",
        area_id: "",
        provinceName: null,
        cityName: null,
        areaName: null,
        userType: 9,
        address: null,
        relation_departCodelist: [],
        relation_departCode: null
      },
      rules: {
        companyName: [
          { required: true, message: "请输入部门名称", trigger: "blur" }
        ],
        depart_type: [
          { required: true, message: "请输入部门类型", trigger: "blur" }
        ],
        departCode: [
          { required: true, message: "请输入部门编码", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    // 获取省下拉
    findByParentCode().then(response => {
      this.province = response.data;
    });
    departtree({ departType: 1 }).then(response => {
      this.departtree = this.getTreeData(response.data);
    });
    this.getdeparttree();
  },
  methods: {
    resetForm() {
      this.form = {
        companyName: null,
        depart_uuid: null,
        parentUserUuidlist: [],
        parentUserUuid: null,
        depart_type: 3,
        departCode: null,
        name: null,
        phone: null,
        province_id: "",
        city_id: "",
        area_id: "",
        provinceName: null,
        cityName: null,
        areaName: null,
        address: null,
        userType: 9,
        relation_departCodelist: [],
        relation_departCode: null
      };
      this.getdeparttree();
    },
    // 分级树单击节点事件
    nodeclick(value) {
      const obj = {
        depart_uuid: value.depart_uuid
      };
      this.Tabledata(obj);
    },
    // 获取市
    getcity(code) {
      let obj = {};
      obj = this.province.find(item => {
        return item.code === code; //筛选出匹配名称
      });
      this.form.provinceName = obj.province;
      this.city = [];
      this.form.city_id = "";
      this.form.area_id = "";
      findByParentCode({ paretnCode: code }).then(response => {
        this.city = response.data;
      });
    },
    // 获取区列表
    getdistrict(code) {
      let obj = {};
      obj = this.city.find(item => {
        return item.code === code; //筛选出匹配名称
      });
      this.form.cityName = obj.city;
      this.district = [];
      this.form.area_id = "";
      findByParentCode({ paretnCode: code }).then(response => {
        this.district = response.data;
      });
    },
    // 获取区名称
    getareaname(code) {
      let obj = {};
      obj = this.district.find(item => {
        return item.code === code; //筛选出匹配名称
      });
      this.form.areaName = obj.area;
    },
    getTreeData(data) {
      // 去除树空子集
      for (var i = 0; i < data.length; i++) {
        if (data[i].listSubWareHouses.length < 1) {
          data[i].listSubWareHouses = undefined;
        } else {
          this.getTreeData(data[i].listSubWareHouses);
        }
      }
      return data;
    },
    // //请求部门树结构
    getdeparttree() {
      departtree({ departType: 3 }).then(response => {
        this.dealertree = this.getTreeData(response.data);
      });
    },
    // 表单确定按钮
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.depart_type === 3) {
            if (
              this.form.relation_departCodelist.length == 0 ||
              this.form.province_id == "" ||
              this.form.city_id == ""
            ) {
              this.$message({
                showClose: true,
                message: "省市与关联的业务部门不能为空！",
                type: "warning"
              });
            } else {
              this.inputform();
            }
          } else {
            this.inputform();
          }
        }
      });
    },
    inputform() {
      // 提交表单方法
      this.form.parentUserUuid = this.form.parentUserUuidlist[
        this.form.parentUserUuidlist.length - 1
      ];
      this.form.relation_departCode = this.form.relation_departCodelist[
        this.form.relation_departCodelist.length - 1
      ];
      registeruser({
        authCode: "Passer",
        codeInfo: null,
        user: this.form,
        userType: 9
      }).then(response => {
        if (response.status_code == 200) {
          this.$message({
            type: "success",
            message: "注册成功!"
          });
          this.search();
          this.resetForm("form");
          this.add.addshow = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>